import PageHeader from "@/components/layout/PageHeader";
import QuickQuoteForm from "@/components/sections/QuickQuoteForm";
import MapEmbed from "@/components/sections/MapEmbed";
import { Phone, MapPin, Clock, MessageCircle, Instagram, Facebook, Youtube } from "lucide-react";
import { BRAND, buildWhatsAppLink } from "@/data/site";

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <PageHeader
        eyebrow="İletişim"
        title="Bize ulaşın,"
        accent="aracınız emin ellerde."
        subtitle="Telefon, WhatsApp veya iletişim formu üzerinden bize ulaşabilir; atölyemizi ziyaret edebilirsiniz."
      />

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-3 gap-5">
          <a
            href={`tel:${BRAND.phoneTel}`}
            data-testid="contact-phone-card"
            className="glass rounded-2xl p-7 card-lift hover:border-gold/50 group"
          >
            <div className="w-12 h-12 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center mb-5 group-hover:bg-gold/20 transition-colors">
              <Phone className="w-5 h-5 text-gold" />
            </div>
            <div className="text-xs uppercase tracking-[0.2em] text-white/55 mb-2">
              Telefon
            </div>
            <div className="font-display font-bold text-xl text-white mb-1">
              {BRAND.phone}
            </div>
            <div className="text-sm text-gold mt-3">Hemen Ara →</div>
          </a>

          <a
            href={buildWhatsAppLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="contact-whatsapp-card"
            className="glass rounded-2xl p-7 card-lift hover:border-[#25D366]/60 group"
          >
            <div className="w-12 h-12 rounded-xl bg-[#25D366]/15 border border-[#25D366]/40 flex items-center justify-center mb-5 group-hover:bg-[#25D366]/30 transition-colors">
              <MessageCircle className="w-5 h-5 text-[#25D366]" />
            </div>
            <div className="text-xs uppercase tracking-[0.2em] text-white/55 mb-2">
              WhatsApp
            </div>
            <div className="font-display font-bold text-xl text-white mb-1">
              7/24 Mesaj Atın
            </div>
            <div className="text-sm text-[#25D366] mt-3">WhatsApp ile Yaz →</div>
          </a>

          <div
            data-testid="contact-address-card"
            className="glass rounded-2xl p-7 card-lift hover:border-inci-blue/60"
          >
            <div className="w-12 h-12 rounded-xl bg-inci-blue/15 border border-inci-blue/40 flex items-center justify-center mb-5">
              <MapPin className="w-5 h-5 text-inci-blue" />
            </div>
            <div className="text-xs uppercase tracking-[0.2em] text-white/55 mb-2">
              Adres
            </div>
            <div className="font-display font-bold text-white leading-tight">
              {BRAND.address}
            </div>
            <a
              href="https://www.google.com/maps/place/Star+Otogaz+-+İnci+Akü+bayi/@39.7958483,30.4937682,15z"
              target="_blank"
              rel="noreferrer"
              className="text-sm text-inci-blue mt-3 inline-block"
            >
              Yol Tarifi Al →
            </a>
          </div>
        </div>
      </section>

      <QuickQuoteForm />

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8 flex items-end justify-between flex-wrap gap-4">
            <div>
              <p className="text-gold uppercase tracking-[0.4em] text-xs mb-3">
                Konum
              </p>
              <h2 className="font-display text-3xl sm:text-4xl font-bold">
                <span className="text-gradient-silver">Atölyemiz</span>{" "}
                <span className="text-gradient-gold">Tepebaşı'nda.</span>
              </h2>
            </div>
            <div className="flex items-center gap-3 text-white/60 text-sm">
              <Clock className="w-4 h-4 text-gold" /> {BRAND.workingHours}
            </div>
          </div>
          <MapEmbed height={500} />
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-white/55 mb-5 text-sm">Sosyal medyada bizi takip edin</p>
          <div className="flex items-center justify-center gap-4">
            {[
              { Icon: Instagram, url: BRAND.social.instagram, label: "Instagram" },
              { Icon: Facebook, url: BRAND.social.facebook, label: "Facebook" },
              { Icon: Youtube, url: BRAND.social.youtube, label: "Youtube" },
            ].map(({ Icon, url, label }) => (
              <a
                key={label}
                href={url}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                className="w-12 h-12 rounded-full border border-white/15 flex items-center justify-center hover:border-gold hover:text-gold hover:scale-110 transition-all"
              >
                <Icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
